
import React, { useState, useEffect } from 'react';
import { toast } from "react-toastify";
import { BASE_URL, instanceAxios } from "../../config";
export default function CategoreItem(props) {
    const [fieldTitle, SetFieldTitle] = useState('');
    const [fontName, SetfontName] = useState('');
    const [selectItemId, SetSelectItemId] = useState('');    
    const [itemorder, SetitemOrder] =useState('');
    const GetListData = () => {

        let config = {
            mode: 'cors',
            method: 'post',
            url: `${BASE_URL}/CategoryItem.ashx`,
            headers: {
                Accept: "application/json",
            },
            data: JSON.stringify({
                Method: 'GetList',
                ParentId: props.parentId,

            })
        };
        instanceAxios(config)
            .then(function (response) {
                if (response.status === 200) {
                    props.SetCategoryData(response.data);
                }
                else {
                    props.SetCategoryData([]);
                }

            })
            .catch((err) => {

            })

    }

    const SaveInfo = () => {

        let config = {
            mode: 'cors',
            method: 'post',
            url: `${BASE_URL}/CategoryItem.ashx`,
            headers: {
                Accept: "application/json",
            },
            data: JSON.stringify({
                Method: 'Insert',
                fieldTitle: fieldTitle,
                fontName: fontName,
                itemorder: itemorder,
                ParentId: props.parentId,
                Id: selectItemId
            })
        };
        instanceAxios(config)
            .then(function (response) {
                if (response.status === 200) {
                    if (selectItemId === '') {
                        toast.success("با موفقیت  ثبت شد", {
                            closeButton: true,
                            autoClose: 1500
                        });
                    }
                    else {
                        toast.info("با موفقیت  ویرایش شد", {
                            closeButton: true,
                            autoClose: 1500
                        });

                    }
                    SetSelectItemId('');
                    SetFieldTitle("");
                    SetfontName("");
                    SetitemOrder("");
                    GetListData();
                }
            })
            .catch((err) => {
                toast.warning(err.response ? 'بروز خطا' + err ?.response ?.data ?.msg : 'بروز خطا' + err.message, {
                    closeButton: false,
                    autoClose: 1500
                });
            })

    }

    const Delete = (_value) => {

        let config = {
            mode: 'cors',
            method: 'post',
            url: `${BASE_URL}/CategoryItem.ashx`,
            headers: {
                Accept: "application/json",
            },
            data: JSON.stringify({
                Method: 'Delete',
                Id: _value
            })
        };
        instanceAxios(config)
            .then(function (response) {
                if (response.status === 200) {
                    GetListData();
                }
            })
            .catch((err) => {
                toast.warning(err.response ? 'بروز خطا' + err ?.response ?.data ?.msg : 'بروز خطا' + err.message, {
                    closeButton: false,
                    autoClose: 1500
                });
            })

    }

    useEffect(() => {
        GetListData();
    }, [])
    const rowclick = (item) => {
        SetfontName(item.fontName);
        SetSelectItemId(item.Id);
        SetFieldTitle(item.fieldTitle);
        SetitemOrder(item.itemorder);
    }

    return (

        <div className="modal" style={{ display: props.showModal === true ? "block" : "none" }}>
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{props.Title}</h5>
                        <button type="button" className="btn-close btn btn-danger" onClick={() => props.SetShowModal(false)} data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="col-sm-12 ">
                            <div className="row p-2 ">
                                <input type="text" className="form-control" style={{ fontSize: "12px",marginTop:"5px" }} placeholder="عنوان" value={fieldTitle} onChange={(e) => SetFieldTitle(e.target.value)} />
                                <input type="text" className="form-control" style={{ fontSize: "12px", marginTop: "5px" }} placeholder="آیکن" value={fontName} onChange={(e) => SetfontName(e.target.value)} />
                                <input type="text" className="form-control" style={{ fontSize: "12px", marginTop: "5px"}} placeholder="ترتیب" value={itemorder} onChange={(e) => SetitemOrder(e.target.value)} />
                                
                            </div>
                            <div>
                                <button type="button" onClick={(e) => SaveInfo()} className="btn btn-default " style={{ width: "80px", fontSize: "14px", backgroundColor: "#e6dcdc", color: "green", marginRight:"10px" }}>
                                    {selectItemId === '' ? <div><i className="ion-plus-round" style={{ fontSize: "14px", marginLeft: "10px" }}></i> <span>ثبت</span></div> : <div><i style={{ fontSize: "14px",marginLeft:"10px" }} className="icon ion-compose"></i><span>ویرایش</span></div>}
                                </button>
                                {
                                    selectItemId !== '' && <button type="button" onClick={(e) => { SetSelectItemId(''); SetFieldTitle(""); SetfontName(""); }} className="btn btn-default" style={{marginRight:"10px", width: "100px", fontSize: "14px", backgroundColor: "#e6dcdc", color: "red" }}>
                                        <i className="icon ion-close-round" style={{ fontSize: "14px",marginLeft:"10px" }}></i> <span>انصراف</span>
                                    </button>
                                }
                                </div>
                        </div>
                        <div className="col-sm-12 ">
                            <div className="row" style={{backgroundColor:"wheat",marginTop:"10px",height:"30px",borderRadius:"4px"}}>
                                <div className="col-sm-5" style={{marginTop:"4px"}}>عنوان</div>
                                <div className="col-sm-2" style={{ marginTop: "4px" }}>آی دی</div>
                                <div className="col-sm-1" style={{ marginTop: "4px" }}> آیکن</div>
                                <div className="col-sm-2" style={{ marginTop: "4px" }}> ترتیب</div>
                                <div className="col-sm-2" style={{ marginTop: "4px" }}> حذف</div>
                            </div>
                            <div  style={{ minHeight: "300px", fontSize: "12px" }}>
                                {
                                    props.CategoryData !== undefined && props.CategoryData !== null && props.CategoryData.length !== 0 &&
                                    props.CategoryData.map((item, i) => {
                                        return <div className="row" style={{ lineHeight: " 30px", backgroundColor: i % 2 === 0 ? "rgba(218, 232, 236, 0.51)" : "rgba(221, 238, 190, 0.51)" }}>
                                            <div className="col-sm-6" onClick={(e) => rowclick(item)} style={{ cursor: "pointer" }}>{item.fieldTitle}</div>
                                            <div style={{ cursor: "pointer", fontSize: "14px", color: "green" }} className="col-sm-1" >{item.Id}</div>
                                            <div className="col-sm-1" onClick={(e) => rowclick(item)} style={{ cursor: "pointer",textAlign:"center" }}> <i className={item.fontName} style={{ fontSize: "20px" }}></i></div>
                                            <div className="col-sm-2" onClick={(e) => rowclick(item)} style={{ cursor: "pointer", textAlign: "center" }}> {item.itemorder   }</div>
                                            <div style={{ cursor: "pointer", fontSize: "14px", color: "red", textAlign: "left"  }} className="col-sm-2" onClick={(e) => Delete(item.Id)}><i className="icon ion-close-round"></i></div>

                                        </div>
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer float-start">
                        <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={() => props.SetShowModal(false)}>بستن</button>
                    </div>
                </div>
            </div>
        </div>



    );
}